import HttpClientToken from '../../services/HttpClientToken';

import { MedioImpugnacionProps, ObtenerMediosImpugnacionParams, ObtenerMediosImpugnacionSentenciaParams } from '../../interfaces/tribunal/MedioImpugnacionInterface';

export const ObtenerMediosImpugnacion = ( params: ObtenerMediosImpugnacionParams ) => {

    return new Promise<MedioImpugnacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/MedioImpugnacion/ObtenerMediosImpugnacion/', params, token)
            .then( ({ data } : { data : MedioImpugnacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerMediosImpugnacionSentencia = ( params: ObtenerMediosImpugnacionSentenciaParams ) => {

    return new Promise<MedioImpugnacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/MedioImpugnacion/ObtenerMediosImpugnacionSentencia/', params, token)
            .then( ({ data } : { data : MedioImpugnacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}
